<template>
    <div class="modal">
        <div class="modal__top">
            <span class="modal__close mb-3" @click="$emit('close')">
                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512"><path d="M178.3 178.3C181.5 175.2 186.5 175.2 189.7 178.3L256 244.7L322.3 178.3C325.5 175.2 330.5 175.2 333.7 178.3C336.8 181.5 336.8 186.5 333.7 189.7L267.3 256L333.7 322.3C336.8 325.5 336.8 330.5 333.7 333.7C330.5 336.8 325.5 336.8 322.3 333.7L256 267.3L189.7 333.7C186.5 336.8 181.5 336.8 178.3 333.7C175.2 330.5 175.2 325.5 178.3 322.3L244.7 256L178.3 189.7C175.2 186.5 175.2 181.5 178.3 178.3V178.3zM512 256C512 397.4 397.4 512 256 512C114.6 512 0 397.4 0 256C0 114.6 114.6 0 256 0C397.4 0 512 114.6 512 256zM256 16C123.5 16 16 123.5 16 256C16 388.5 123.5 496 256 496C388.5 496 496 388.5 496 256C496 123.5 388.5 16 256 16z"/></svg>
            </span>
        </div>
        <div class="modal__box">
            <div class="search-auto-complete" data-float-labels data-float-labels-class-prefix="form-field">
                <div class="form-field form-field--floated-label">
                    <input 
                        type="text"
                        ref="searchInput"
                        v-model="search"
                        @input="onChange"
                        @keydown.down="onArrowDown"
                        @keydown.up="onArrowUp"
                        @keydown.enter="onEnter" 
                        autocomplete="off" 
                    />
                    <label for="search">Search</label>
                </div>
                <ul id="autocomplete-results" v-show="isOpen" class="search-auto-complete__results">
                    <li class="loading" v-if="isLoading">Loading results...</li>
                    <li 
                        v-else 
                        v-for="(result, i) in results" 
                        :key="i" 
                        @click="setResult(result)"
                        class="search-auto-complete__result"
                        :class="{ 'search-auto-complete__result--is-active': i === arrowCounter }">
                        {{ result }}
                    </li>
                </ul>
            </div>
            <div class="d-flex justify-content-end mt-2">
                <button
                    @click="submitSearch" 
                    class="button button--secondary button--has-icon" 
                    aria-label="Search site"
                    :disabled="!search.trim()"
                >
                    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 448 512"><path d="M429.8 273l17-17-17-17L276.2 85.4l-17-17-33.9 33.9 17 17L354.9 232 24 232 0 232l0 48 24 0 330.8 0L242.2 392.6l-17 17 33.9 33.9 17-17L429.8 273z"/></svg>
                </button>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'search-modal',
    data() {
        return {
            isOpen: false,
            results: [],
            search: '',
            arrowCounter: -1,
        };
    },
    props: {
        searchUrl: {
            type: String,
            required: false,
            default: '/search'
        },
        initialItems: {
            type: Array,
            required: true,
        }
    },
    computed: {
        isLoading() {
            return this.$store.state.isLoading;
        },
        errorMessage() {
            return this.$store.state.errorMessage;
        },
    },
    watch: {
        search(newVal) {
            this.filterResults();
        }
    },
    methods: {
        setResult(result) {
            this.search = result;
            this.isOpen = false;
        },
        filterResults() {
            this.results = this.initialItems.filter((item) => {
                return item.toLowerCase().includes(this.search.toLowerCase());
            });
        },
        onChange() {
            this.$emit('input', this.search);
            this.filterResults();
            this.isOpen = true;
        },
        handleClickOutside(event) {
            if (!this.$el.contains(event.target)) {
                this.isOpen = false;
                this.arrowCounter = -1;
            }
        },
        onArrowDown() {
            if (this.arrowCounter < this.results.length - 1) {
                this.arrowCounter += 1;
            }
        },
        onArrowUp() {
            if (this.arrowCounter > 0) {
                this.arrowCounter -= 1;
            }
        },
        onEnter(event) {
            if (!this.search.trim()) {
                event.preventDefault();
            } else if (this.isOpen && this.arrowCounter !== -1) {
                event.preventDefault();
                this.search = this.results[this.arrowCounter];
                this.isOpen = false;
                this.arrowCounter = -1;
            } else if (this.search.trim()) {
                this.submitSearch();
            }
        },
        submitSearch() {
            const searchString = `?query=${this.search}`;
            window.location.href = this.searchUrl + searchString;
        }
    },
    mounted() {
        this.results = this.initialItems;

        this.$nextTick(() => {
            this.isOpen = true;
        });

        this.$nextTick(() => {
            this.$refs.searchInput.focus();
        });

        document.addEventListener('click', this.handleClickOutside);
    },
    destroyed() {
        document.removeEventListener('click', this.handleClickOutside);
    },
    updated() {
        import('../../partials/_float-labels').then(({ floatLabels }) => floatLabels());
    },
};
</script>